import React from 'react';
import { Box, Typography } from '@mui/material';

interface MessageProps {
  message: any;
}

const formatText = (text: any): string => {
  if (typeof text !== 'string') return '';
  
  return text
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/\*(.*?)\*/g, '<b>$1</b>')        
    .replace(/_(.*?)_/g, '<i>$1</i>')        
    .replace(/~(.*?)~/g, '<s>$1</s>')       
    .replace(/```(.*?)```/g, '<code>$1</code>') 
    .replace(/(https?:\/\/[^\s]+)/g, '<a href="$1" target="_blank" rel="noopener noreferrer">$1</a>') // link
    .replace(/\n/g, '<br />');                 
};


const MessageAddress: React.FC<MessageProps> = ({ message }) => {
  try {
    const content = message?.content || {};
    const headerText = content?.header?.text || '';
    const bodyText = content?.body?.text || '';
    const footerText = content?.footer?.text || '';

    return (
      <Box>
        {/* Header */}
        {headerText && (
          <Typography variant="subtitle1" fontWeight="bold" gutterBottom dangerouslySetInnerHTML={{ __html: formatText(headerText) }}
>
            {/* {headerText} */}
          </Typography>
        )}

        {/* Body */}
        {bodyText && (
          <Typography
            variant="body2"
            sx={{ whiteSpace: 'pre-wrap', mb: footerText ? 2 : 0 }}
            dangerouslySetInnerHTML={{ __html: formatText(bodyText) }}
          >
            {/* {bodyText} */}
          </Typography>
        )}

        {/* Footer */}
        {footerText && (
          <Typography
            variant="caption"
            color="text.secondary"
            display="block"
            mt={1}
           dangerouslySetInnerHTML={{ __html: formatText(footerText) }}
          >
            {/* {footerText} */}
          </Typography>
        )}
      </Box>
    );
  } catch (error) {
    return <Typography color="error">Error displaying address message</Typography>;
  }
};

export default MessageAddress;
